<template>
    <div v-show="getListContacts" class="contacts">
        <div class="col-md-12">
            <h3>Clientes da base</h3>
            <table id="relLog" ref='tabela' class="table display table-hover table-striped" style="width: 100%">
                <thead></thead>
                <tbody></tbody>
                <tfoot></tfoot>
            </table>
        </div>

        <component :is="comp" :data="compData" v-on:dismissModal="dismissModal" />
    </div>
</template>

<script>
import modalCostumers from './ModalCostumersTOperador';
import { mapGetters } from "vuex";

import VueTheMask from 'vue-the-mask';

Vue.use(VueTheMask)

export default {
    components: { modalCostumers },
    props: {
        filter: {
            type: String,
            default: ''
        },
        upList: 0
    },
    data() {
        return {
            dt: null,
            val: this.filter,
            comp: '',
            compData: '',
            contactEquipeOption: '',
        }
    },
    watch: {
        getListContacts(newValue) {
            if (newValue) {
                this.createTable();
            }
        },
        upList: function () {
            this.createTable()
        },
        filter: {
            handler: function (val) {
                this.createTable()
            },
            deep: true
        }
    },
    computed: {
        ...mapGetters(["getListContacts"]),
    },
    methods: {
        dismissModal() {
            this.comp = '';
            this.createTable();
        },
        formatCpfCnpj(value) {
            if (!value) return "";
            const numValue = value.replace(/\D/g, "")
            if (numValue.length === 11) {
                return numValue.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, "$1.$2.$3-$4");
            } else if (numValue.length === 14) {
                return numValue.replace(/(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, "$1.$2.$3/$4-$5");
            } else {
                return value;
            }
        },
        async createTable() {
            try {
                // Aguarde a resposta da API antes de continuar
                const { data } = await axios.get('/queue-contacts');
                this.contactEquipeOption = data;

                // Destruir a instância anterior do DataTable, se existir
                if (this.dt) {
                    $('#relLog').DataTable().destroy();
                }

                // Agora inicialize o DataTable
                this.dt = $('#relLog').DataTable({
                    responsive: true,
                    processing: true,
                    serverSide: true,
                    destroy: true,
                    autoWidth: false, // Impede o DataTable de recalcular automaticamente as larguras
                    ajax: {
                        type: "GET",
                        url: '/customer_base/getclients'
                    },
                    columns: [
                        { "data": "name", 'title': 'Nome' },
                        { "data": "phone", className: 'text-center', 'title': 'Telefone' },
                        { "data": "unique_key", className: 'text-center', 'title': 'CPF / CNPJ', render: (data) => this.formatCpfCnpj(data) },
                        { "data": "cpd", className: 'text-center', 'title': 'CPD' },
                        { "data": "grupo", className: 'text-center', 'title': 'Grupo' },
                        { "data": "divisao", className: 'text-center', 'title': 'Divisão' },
                        { "data": "estado", className: 'text-center', 'title': 'Estado' },
                        {
                            class: 'details-control find-data text-center',
                            data: 'id',
                            'title': 'Detalhes',
                            render: () => `<button type='button' class='find-data invisible-button detail-button'><i class='find-data fa fa-search-plus'></i></button>`
                        }
                    ],
                    order: [[0, 'asc']]
                });
            } catch (error) {
                console.error("Erro ao carregar dados de filas: ", error);
            }
        }

    },
    mounted() {
        this.createTable();

        document.querySelector('#relLog tbody').addEventListener('click', (e) => {

            if (e.target.classList.contains('find-data')) {
                const tr = e.target.closest('tr');
                const row = this.dt.row(tr).data();
                this.compData = row;
                this.comp = 'modal-costumers'
            }

        });
    }

}
</script>

<style>
.detail-button {
    font-size: 18px !important;
    color: #1c869a;
}

.detail-button:hover {
    color: #0c4955;
    transition: 0.5s;
}
</style>